import React from 'react';

const Footer = () => {
  return (
    <footer className="footer-v1 bg-26035D text-white">
      <div className="container-lg inner-container">
        <div className="row foot-top-row">
          <div className="col-md-4">
            <div className="addr-content">
              <a href="index.html"><img src="assets/img/logo.svg" alt="logo" /></a>
              <p className="cp-right ">©2024 Purplepatch Services LLC<br /> 1248 Reamwood Avenue, Sunnyvale CA 94089<br /> <a href="#">Privacy Policy</a></p>

              <div className="foot-contact">
                <ul className="mail-phone">
                  <li>Email: <a href="mailto:ask@purplepatchservices.com">ask@purplepatchservices.com</a></li>
                  <li>Phone: <a href="tel:408.743.4424">408.743.4424</a></li>
                </ul>
                <div className="foot-social">
                  <ul className="list-inline">
                    <li>
                      <a href="https://twitter.com/purplepatch_llc" target="_blank"><i className="fa-brands fa-x-twitter"></i></a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/purplepatchservices/" target="_blank"><i className="fa-brands fa-facebook-f"></i></a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/purplepatch-services-llc" target="_blank"><i className="fa-brands fa-linkedin-in"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8">
            <div className="row row-foot-menu">
              <div className="col-md-6 col-lg-6 col-sm-8">
                <h5><a href="our-services.html">Our Services</a></h5>
                <ul>
                  <li><a href="/abm">Account-Based Marketing</a></li>
                  <li><a href="/ContentMarketing">Content Marketing</a></li>
                  <li><a href="/LeadGeneration">Lead Generation</a></li>
                  <li><a href="/WebDesign">Website Design and Development</a></li>
                  <li><a href="/SEO">Search Engine Optimization (SEO)</a></li>
                  <li><a href="/SocialMarketing">Social Media Marketing</a></li>
                  <li><a href="/EmailMarketing">Email Marketing</a></li>
                  <li><a href="/ppc">Paid Advertising</a></li>
                  <li><a href="/MarketingAutomation">Marketing Automation</a></li>
                </ul>
              </div>
              <div className="col-md-4 col-lg-6 col-sm-4 col-6">
                <h5><a href="">About Us</a></h5>
                <ul>
                  <li><a href="/OurStory">Our Story</a></li>
                  <li><a href="/portfolio">Portfolio</a></li>
                </ul>
              </div>
              <div className="col-md-4 col-sm-4 col-6">
                <h5><a href="/SuccessStories">Success Stories</a></h5>
              </div>
              <div className="col-md-4 col-sm-4 col-6">
                <h5><a href="#">Resources</a></h5>
                <ul>
                  <li><a href="#">Blog</a></li>
                  <li><a href="/ebook">E-Book</a></li>
                </ul>
              </div>
              <div className="col-md-4 col-sm-4 col-6">
                <h5><a href="/Contact">Contact</a></h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
